export default "<div>\n  <div>\n    <p>Reason: {{ data.reason }}</p>\n    <p>Status: {{ data.status }}</p>\n  </div>\n</div>\n";